/* eslint-disable semi,semi-style */
import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { SWRConfig } from 'swr';
import feMonitor from '@didi/fe-monitor';
import App from './app';
import request from '@/util/request';
import useSign from '@/util/sign';
useSign();
// 初始化
feMonitor.setConfig({
  appid: '10027',
  moduleName: 'epower-open',
  auto: true,
});

render(
  <SWRConfig
    value={{
      fetcher: request,
    }}>
    <App />
  </SWRConfig>,
  document.getElementById('epower-open-root'),
);
